import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'cloudlabs-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.scss']
})
export class ImagePreviewComponent implements OnInit, OnDestroy {
  imageUrl
  constructor(
  ) {
    //
  }
  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event) {window.close();
  }

  @HostListener('window:unload', ['$event'])
  unloadHandler(event: Event) {
    window.close();
  }

  ngOnInit(): void {
    this.imageUrl = localStorage.getItem('image_url')
    if(this.imageUrl) {
      localStorage.removeItem('image_url')
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener('beforeunload', this.beforeUnloadHandler);
  }

}